<div class="file-drop">
    <!-- On phones there's no drag-and-drop, so a preview-less drop square is dead space: hide it and rely on the "Choisir un fichier" button. -->
    <div *ngIf="!(isPhone && noPreview)" class="image-wrapper {{ fileOver ? 'file-over' : '' }}{{ noPreview ? ' no-preview' : ''}}"
        [ngStyle]="{'background-image': image ? 'url(' + image + ')' : 'none', 'width': width ? width + 'px' : '100%', 'height': height ? height + 'px' : '140px'}"
        (click)="fileInput.click()">
        <!-- <img *ngIf="image" [src]="image" alt="Image"> -->

        <div *ngIf="(!image && !files) || noPreview" class="placeholder" >
            <mat-icon>cloud_upload</mat-icon>
            <span>{{ 'form.drop_file' | translate }}</span>
        </div>
        <div *ngIf="!image && files && files.length && !noPreview" class="placeholder">
            <mat-icon>file_copy</mat-icon>
            <span>{{ files.length}} @if(files.length > 1) { {{ 'form.files' | translate }} } @else { {{ 'form.file' | translate }} }</span>
        </div>
    </div>

    <div class="actions">
        <lib-button *ngIf="camera && isPhone && (!image || noPreview)" [color]="'secondary'" [icon]="'photo_camera'"
            [tooltip]="'form.take_photo' | translate" (click)="cameraOpen = true">
        </lib-button>
        <lib-button *ngIf="!image || noPreview" [color]="'secondary'" [icon]="'folder_open'" [text]="'form.choose_file' | translate"
            (click)="fileInput.click()">
        </lib-button>
        <input hidden (change)="onFileSelected($event)" #fileInput type="file" accept="{{accept}}" [attr.multiple]="multiple || null">
        <lib-button *ngIf="image && delete && !noPreview" [color]="'danger'" [icon]="'delete'" (click)="onDelete()">
        </lib-button>
    </div>
</div>

<lib-camera-capture *ngIf="cameraOpen" (captured)="onCameraCapture($event)" (closed)="cameraOpen = false"></lib-camera-capture>